import { render, staticRenderFns } from "./EventAttendees.vue?vue&type=template&id=3b338143&scoped=true"
import script from "./EventAttendees.vue?vue&type=script&lang=js"
export * from "./EventAttendees.vue?vue&type=script&lang=js"
import style0 from "./EventAttendees.vue?vue&type=style&index=0&id=3b338143&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b338143",
  null
  
)

export default component.exports